import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TokenDialog from "./TokenDialog";
import ThemeToggle from "./ThemeToggle";
import { createThirdwebClient } from "thirdweb";
import { ConnectButton } from "thirdweb/react";
import { darkTheme, lightTheme } from "thirdweb/react";
import { bsc } from "thirdweb/chains";
import { createWallet } from "thirdweb/wallets";
import { useTheme } from "../contexts/ThemeContext";

const logo = "/Dexora.png";

const Header = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);
    const [, setSelected] = useState("ETH");
    const { theme } = useTheme();

    const client = createThirdwebClient({
        clientId: process.env.REACT_APP_THIRD_WEB_CLIENT,
    });

    const themeCreator = theme === 'dark' ? darkTheme : lightTheme;
    const customTheme = themeCreator({
        colors: {
            primaryButtonBg: theme === 'dark' ? "#D4A843" : "#B8892B",
            primaryButtonText: theme === 'dark' ? "#0A0A0F" : "#FFFFFF",
            modalBg: theme === 'dark' ? "#111117" : "#FFFFFF",
            borderColor: theme === 'dark' ? "rgba(212, 168, 67, 0.2)" : "rgba(184, 137, 43, 0.3)",
            accentText: theme === 'dark' ? "#D4A843" : "#9A7020",
            separatorLine: theme === 'dark' ? "rgba(212, 168, 67, 0.1)" : "rgba(184, 137, 43, 0.15)",
            secondaryButtonBg: theme === 'dark' ? "rgba(212, 168, 67, 0.1)" : "rgba(184, 137, 43, 0.1)",
            secondaryButtonHoverBg: theme === 'dark' ? "rgba(212, 168, 67, 0.2)" : "rgba(184, 137, 43, 0.15)",
            secondaryButtonText: theme === 'dark' ? "#D4A843" : "#9A7020",
            connectedButtonBg: theme === 'dark' ? "#111117" : "#FBF6EC",
            connectedButtonBgHover: theme === 'dark' ? "#1E1E28" : "#F0DDB8",
        },
    });


    return (
        <div className="flex bg-dexora-dark-secondary/80 backdrop-blur-md px-2 sm:px-4 lg:px-8 lg:mx-auto w-full h-[72px] justify-between header-3d">
            <div className="flex gap-1 sm:gap-4 justify-start sm:justify-center items-center shrink-0">
                <div className="flex items-center cursor-pointer transition-transform hover:scale-110" onClick={() => navigate("/")}>
                    <img src={logo} className="h-[128px] w-auto" alt="Dexora" />
                </div>
                <div className="hidden md:flex items-center ml-6 nav-tabs-3d rounded-full p-1">
                    {[
                        { label: "Swap", path: "/", isActive: pathname === "/" },
                        { label: "Bridge", path: "/bridge", isActive: pathname.startsWith("/bridge") },
                        { label: "Trade", path: "https://www.dexora.exchange/trade/BTC", isActive: false, external: true },
                        { label: "Prediction", path: "https://predict.dexora.live/", isActive: false, external: true },
                        { label: "Pools", path: "/pool", isActive: pathname.startsWith("/pool") || pathname.includes("/remove") },
                        { label: "Dexorbit", path: "https://dexora.live/", isActive: false, external: true },
                    ].map((tab) => (
                        <button
                            key={tab.label}
                            onClick={() => tab.external ? window.open(tab.path, '_blank') : navigate(tab.path)}
                            className={`px-3 lg:px-5 py-2 rounded-full text-[13px] lg:text-[14px] font-bold transition-all duration-300 ${tab.isActive
                                ? "nav-tab-active"
                                : "text-dexora-text-muted hover:text-dexora-text-primary"
                                }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
            <div className="flex gap-2 sm:gap-6 justify-center items-center pt-2 pb-2">
                <ConnectButton
                    connectButton={{
                        label: "Connect Wallet",
                        style: {
                            borderRadius: "64px",
                            background: "linear-gradient(135deg, #F5D978 0%, #D4A843 45%, #B8892B 80%, #9A7020 100%)",
                            color: "#0A0A0F",
                            fontWeight: "600",
                        },
                    }}
                    connectModal={{
                        title: "Sign in with Dexora",
                        titleIcon: logo,
                        size: "wide",
                        welcomeScreen: {
                            title: "Your gateway to the decentralized world",
                            subtitle: "Connect a wallet to get started",
                            img: {
                                src: logo,
                                height: 150,
                                width: 150,
                            },
                        },
                    }}
                    detailsButton={{
                        style: {
                            borderRadius: "64px",
                            background: theme === 'dark' ? "rgba(212, 168, 67, 0.1)" : "rgba(184, 137, 43, 0.1)",
                            color: theme === 'dark' ? "#D4A843" : "#B8892B",
                            border: theme === 'dark' ? "1px solid rgba(212, 168, 67, 0.2)" : "1px solid rgba(184, 137, 43, 0.2)",
                        },
                    }}
                    wallets={[
                        createWallet("io.metamask"),
                        createWallet("com.coinbase.wallet"),
                        createWallet("me.rainbow"),
                        createWallet("io.rabby"),
                        createWallet("app.phantom"),
                        createWallet("com.trustwallet.app"),
                        createWallet("walletConnect"),
                    ]}
                    chains={[bsc]}
                    client={client}
                    theme={customTheme}
                    autoConnect={true}
                />
                <ThemeToggle />
                <TokenDialog open={open} setOpen={setOpen} onClick={setSelected} />
            </div>
        </div>
    );
};

export default Header;
